function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { mergeWith, objectKeys } from "@chakra-ui/utils";
import { background, border, color, effect, filter, flexbox, grid, interactivity, layout, list, others, position, ring, space, textDecoration, transform, transition, typography } from "./config";
import { pseudoPropNames, pseudoSelectors } from "./pseudos";
export var systemProps = mergeWith({}, background, border, color, flexbox, layout, filter, ring, interactivity, grid, others, position, effect, space, typography, textDecoration, transform, list, transition);
var layoutSystem = Object.assign({}, space, layout, flexbox, grid, position);
export var layoutPropNames = objectKeys(layoutSystem);
export var propNames = [...objectKeys(systemProps), ...pseudoPropNames];

var styleProps = _extends({}, systemProps, pseudoSelectors);

export var isStyleProp = prop => prop in styleProps;
//# sourceMappingURL=system.js.map